<template>
  <div class="home">
    <NavigationBar />
    <About />
    <VideoPopUp v-if="!$store.state.closePopUp" />
    <Dishes />
    <History />
    <Video />
    <FoodMenu />
    <Team />
    <Feedback />
    <LatestNews />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavigationBar from "@/components/NavigationBar.vue";
import About from "@/components/About.vue";
import VideoPopUp from "@/components/VideoPopUp.vue";
import Dishes from "@/components/Dishes.vue";
import History from "@/components/History.vue";
import Video from "@/components/Video.vue";
import FoodMenu from "@/components/FoodMenu.vue";
import Team from "@/components/Team.vue";
import Feedback from "@/components/Feedback.vue";
import LatestNews from "@/components/LatestNews.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "home",
  components: {
    NavigationBar,
    About,
    VideoPopUp,
    Dishes,
    History,
    Video,
    FoodMenu,
    Team,
    Feedback,
    LatestNews,
    Footer
  }
};
</script>

<style lang="scss">
body {
  height: auto;
}
</style>
